/**
 * 订单管理 交易订单（第二版本界面）
 */
<template>
  <div class="order">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item >交易订单</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 订单列表 s -->
      <div class="box-table" v-show="!detailShow">

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <el-select size="small" :clearable="true" v-model="formInline.state" placeholder="订单状态">
                    <el-option v-for="item in orderStatus" :key="item.value" :label="item.key" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <el-input size="small" :clearable="true" v-model="formInline.orderNo" placeholder="输入订单号"></el-input>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-date-picker size="small" v-model="daterange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="left">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content bg-purple">
                  <el-form-item>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  </el-form-item>
                </div>
              </el-col>
              <!-- 导出 -->
              <el-col :span="2">
                <div class="grid-content bg-purple">
                  <!-- <el-form-item>
                    <el-button size="mini" type="primary" plain icon="el-icon-download">导出excel</el-button>
                  </el-form-item> -->
                </div>

              </el-col>
            </el-row>

          </el-form-item>

        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column sortable prop="orderNo" label="订单号" >
          </el-table-column>
          <el-table-column sortable prop="createTime" label="下单时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="type" label="订单类型" show-overflow-tooltip >
          </el-table-column> -->
          <!-- <el-table-column sortable prop="goodsName" label="产品名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="goodsCategory" label="产品分类" width="140">
          </el-table-column> -->
          <el-table-column sortable prop="state" label="订单状态">
            <template slot-scope="scope">
              <span>{{scope.row.state | state}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="amount" label="金额" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.amount | rounding}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template  slot-scope="scope">
              <el-button type="text" size="mini" @click="openDetail(scope.row.id)">详情</el-button>

            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 订单列表 e -->
      <!-- 订单详情 s -->
      <Details v-if="detailShow" @closeDialog="closeDialog" v-bind:id="orderId"></Details>
      <!-- 订单详情 e -->
    </el-card>

  </div>
</template>

<script>
import { OrderList, } from '../../api/orderMG'
import Pagination from '../../components/Pagination'
import Details from '../../components/order/details.vue'
import moment from 'moment'
export default {
  data() {
    return {
      detailShow: false,
      loading: false, //是显示加载
      orderId: null,
      payType: [
        { key: '新购', value: 1 },
        { key: '升级', value: 2 },
        { key: '降级', value: 3 },
        { key: '续费', value: 4 },
        { key: '扩容', value: 4 }
      ],
      orderStatus: [
        { key: '交易完成', value: 1 },
        { key: '订单终止', value: 2 },
        { key: '订单中止', value: 0 },
        { key: '订单作废', value: 3 }
      ],

      formInline: {
        page: 1,
        pageSize: 10,
        orderNo: '',
        state: null,
      },
      listData: [], //用户数据
      // daterange:[moment(new Date()).add(-1, 'month'),new Date()],
      
      daterange:['', ''],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    Details
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单列表
    getdata(parameter) {
      if(this.daterange[0]){
        const start = moment(this.daterange[0]).format('yyyy-MM-DD 00:00:00')
        // const start = moment(this.daterange[0]).startOf('day').format('x')
        parameter['searchStartTime'] = start
      }
      if(this.daterange[1]){
        const end = moment(this.daterange[1]).format('yyyy-MM-DD 23:59:59')
        // const end = moment(this.daterange[1]).endOf('day').format('x')
        parameter['searchEndTime'] = end
      }
      OrderList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.count
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      
      this.getdata(this.formInline)
    },
    // 关闭详情
    closeDialog(data) {
      this.detailShow = data.show
    },
    //显示编辑界面
    openDetail(id) {
     this.orderId = id
     this.detailShow=!this.detailShow
    },
  },
  filters: {
    rounding(value) {
      return value.toFixed(2)
    },
    state(num) {
      switch (num) {
        case 0:
          return '订单中止'
        case 1:
          return '交易完成'
        case 2:
          return '订单终止'
        case 3:
          return '订单废弃'
        default:
          return '交易完成'
      }
    },
  }
}
</script>

<style scoped>
.box-table{
  height: 500px
}
.box-card {
  margin-top: 20px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue